import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Typography,
    Box
} from '@mui/material';

const CB_CORG_AND_HC_SAMPLES_HEADERS = [
    'Sample',
    'Sample Date',
    'Sample Type (IPS or RS)',
    'H:Corg - Test Value',
    'Organic C Content (OCb) - Test Value',
    'Upload Lab Report'
]

const CONTAMINANTS_HEADERS = [
    'Sample',
    'Sample Date',
    'Sample Type (IPS or RS)',
    'PCBs',
    'PCDD/Fs',
    'PAHs',
    'Upload Lab Report'
]

export default function CbCorgAndHcSamples({ sampleData, contaminantsData }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h5">
                    Biochar Lab Samples (C_ORG & H:C)
                </Typography>
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                {CB_CORG_AND_HC_SAMPLES_HEADERS.map((header) => (
                                    <TableCell
                                        key={header}
                                        align='left'>
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sampleData?.map((sample, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left">{sample.sample}</TableCell>
                                    <TableCell align="left">{sample.sampleDate}</TableCell>
                                    <TableCell align="left">{sample.sampleType}</TableCell>
                                    <TableCell align="left">{sample.hCorgTestValue}</TableCell>
                                    <TableCell align="left">{sample.cTestValue}</TableCell>
                                    <TableCell align="left">{sample.labReport}</TableCell>
                                </TableRow>
                            )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h5">
                    Biochar Lab Samples (Contaminants)
                </Typography>
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                {CONTAMINANTS_HEADERS.map((header) => (
                                    <TableCell
                                        key={header}
                                        align='left'>
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contaminantsData?.map((contaminant, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left">{contaminant.sample}</TableCell>
                                    <TableCell align="left">{contaminant.sampleDate}</TableCell>
                                    <TableCell align="left">{contaminant.sampleType}</TableCell>
                                    <TableCell align="left">{contaminant.pcb}</TableCell>
                                    <TableCell align="left">{contaminant.pcdd}</TableCell>
                                    <TableCell align="left">{contaminant.pahs}</TableCell>
                                    <TableCell align="left">{contaminant.labReport}</TableCell>
                                </TableRow>
                            )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Box>
    )
}
